import urlTemplate from 'url-template';
export let PARTNER_NAV_ITEMS = /*#__PURE__*/function (PARTNER_NAV_ITEMS) {
  PARTNER_NAV_ITEMS["APPS"] = "APPS";
  PARTNER_NAV_ITEMS["DETAILS"] = "DETAILS";
  PARTNER_NAV_ITEMS["TEAM"] = "TEAM";
  PARTNER_NAV_ITEMS["PAYMENT_INFO"] = "PAYMENT_INFO";
  PARTNER_NAV_ITEMS["PROMOTIONS"] = "PROMOTIONS";
  PARTNER_NAV_ITEMS["SECURITY"] = "SECURITY";
  PARTNER_NAV_ITEMS["REPORTS"] = "REPORTS";
  PARTNER_NAV_ITEMS["ADMIN"] = "ADMIN";
  PARTNER_NAV_ITEMS["AUDIT_LOGS"] = "AUDIT_LOGS";
  PARTNER_NAV_ITEMS["SALE_REPORTS"] = "SALE_REPORTS";
  PARTNER_NAV_ITEMS["EVALUATIONS_REPORTS"] = "EVALUATIONS_REPORTS";
  PARTNER_NAV_ITEMS["FEEDBACK_REPORTS"] = "FEEDBACK_REPORTS";
  PARTNER_NAV_ITEMS["CLOUD_CONVERSIONS_REPORTS"] = "CLOUD_CONVERSIONS_REPORTS";
  PARTNER_NAV_ITEMS["CLOUD_RENEWALS_REPORTS"] = "CLOUD_RENEWALS_REPORTS";
  PARTNER_NAV_ITEMS["CLOUD_CHURN_REPORTS"] = "CLOUD_CHURN_REPORTS";
  PARTNER_NAV_ITEMS["TRANSACTIONS_REPORTS"] = "TRANSACTIONS_REPORTS";
  PARTNER_NAV_ITEMS["LICENSES_REPORTS"] = "LICENSES_REPORTS";
  PARTNER_NAV_ITEMS["FEEDBACK_DETAILS_REPORTS"] = "FEEDBACK_DETAILS";
  PARTNER_NAV_ITEMS["CREATE_PROMOTION"] = "CREATE_PROMOTION";
  PARTNER_NAV_ITEMS["PROMOTION_DETAILS"] = "PROMOTION_DETAILS";
  PARTNER_NAV_ITEMS["CODES"] = "CODES";
  PARTNER_NAV_ITEMS["PRICING"] = "PRICING";
  return PARTNER_NAV_ITEMS;
}({});
export const managePartnerBaseLink = () => urlTemplate.parse('/manage/vendors/{id}');
export const getPartnerNavLinks = () => ({
  /* Manage Partner navigation links */
  [PARTNER_NAV_ITEMS.APPS]: urlTemplate.parse('/manage/vendors/{id}/addons'),
  [PARTNER_NAV_ITEMS.DETAILS]: urlTemplate.parse('/manage/vendors/{id}/details'),
  [PARTNER_NAV_ITEMS.TEAM]: urlTemplate.parse('/manage/vendors/{id}/contacts'),
  [PARTNER_NAV_ITEMS.PAYMENT_INFO]: urlTemplate.parse('/manage/vendors/{id}/payment'),
  [PARTNER_NAV_ITEMS.REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/{key}'),
  [PARTNER_NAV_ITEMS.PROMOTIONS]: urlTemplate.parse('/manage/vendors/{id}/promos'),
  [PARTNER_NAV_ITEMS.SECURITY]: urlTemplate.parse('/manage/vendors/{id}/security'),
  [PARTNER_NAV_ITEMS.ADMIN]: urlTemplate.parse('/manage/vendors/{id}/admin'),
  [PARTNER_NAV_ITEMS.AUDIT_LOGS]: urlTemplate.parse('/manage/vendors/{id}/auditlogs'),
  /* Reports nested navigation links */
  [PARTNER_NAV_ITEMS.SALE_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/sales?period=past90Days'),
  [PARTNER_NAV_ITEMS.EVALUATIONS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/evaluations?period=past90Days'),
  [PARTNER_NAV_ITEMS.FEEDBACK_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/feedback?period=past90Days'),
  [PARTNER_NAV_ITEMS.CLOUD_CONVERSIONS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/conversions?period=past90Days'),
  [PARTNER_NAV_ITEMS.CLOUD_RENEWALS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/renewals?period=past90Days'),
  [PARTNER_NAV_ITEMS.CLOUD_CHURN_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/churn?period=past90Days'),
  [PARTNER_NAV_ITEMS.TRANSACTIONS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/transactions'),
  [PARTNER_NAV_ITEMS.LICENSES_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/licenses'),
  [PARTNER_NAV_ITEMS.FEEDBACK_DETAILS_REPORTS]: urlTemplate.parse('/manage/vendors/{id}/reporting/feedback-details'),
  /* Promotions sub tab links */
  [PARTNER_NAV_ITEMS.CREATE_PROMOTION]: urlTemplate.parse('/manage/vendors/{id}/promos/create'),
  [PARTNER_NAV_ITEMS.PROMOTION_DETAILS]: urlTemplate.parse('/manage/vendors/{id}/promos/{key}/details'),
  [PARTNER_NAV_ITEMS.CODES]: urlTemplate.parse('/manage/vendors/{id}/promos/{key}/codes'),
  [PARTNER_NAV_ITEMS.PRICING]: urlTemplate.parse('/manage/vendors/{id}/promos/{key}/pricing')
});